import AutoDismissFlag from '@atlaskit/flag/auto-dismiss-flag';

import FlagGroup from '@atlaskit/flag/flag-group';

import CheckCircleIcon from '@atlaskit/icon/core/check-circle';

import { token } from '@atlaskit/tokens';

import { useFirePostOfficeAnalyticsEvents } from '@post-office/analytics';

import { FormattedMessage, useIntl } from 'react-intl';

import { CAROUSEL_DISMISSAL_FLAG_ID } from '../constants';

import { messages } from '../messages';

type CarouselDismissalFlagProps = {
	handleDismissFlag: () => void;
};

export const CarouselDismissalFlag = ({
	handleDismissFlag,
}: CarouselDismissalFlagProps): JSX.Element => {
	const handleLinkClick = () => {
		fireAnalyticsEvent({
			eventType: 'ui',
			action: 'clicked',
			actionSubject: 'carouselDismissalFlag',
			actionSubjectId: 'carouselDismissalFlagCtaLink',
		});
	};

	const intl = useIntl();
	const { fireAnalyticsEvent } = useFirePostOfficeAnalyticsEvents();

	return (
		<FlagGroup onDismissed={handleDismissFlag}>
			<AutoDismissFlag
				id={CAROUSEL_DISMISSAL_FLAG_ID}
				icon={
					<CheckCircleIcon
						label="" // presentation only
						size="medium"
						color={token('color.icon.accent.green')}
					/>
				}
				key={CAROUSEL_DISMISSAL_FLAG_ID}
				title={intl.formatMessage(messages.dismissalFlagHeading)}
				description={intl.formatMessage(messages.dismissalFlagDescription)}
				actions={[
					{
						content: <FormattedMessage {...messages.dismissalFlagLinkText} />,
						href: 'https://www.atlassian.com/blog/announcements/teamwork-collection',
						onClick: handleLinkClick,
					},
				]}
				testId={CAROUSEL_DISMISSAL_FLAG_ID}
			/>
		</FlagGroup>
	);
};
